module.exports = __webpack_public_path__ + "img/avatar2.31721699.svg";